export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/pdfFile.57cf15d6.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};